import {create} from 'zustand'

type RefetchFunctionsType = Record<string, Set<() => void>>

interface RefetchState {
  refetchFunctions: RefetchFunctionsType
  registerRefetch: (key: string, refetch: () => void) => void
  unregisterRefetch: (key: string, refetch: () => void) => void
  triggerRefetch: (key: string) => void
  triggerAllRefetch: () => void
}

/**
 * Zustand store for refetch functionality
 * Replaces RefetchContext/RefetchProvider
 */
export const useRefetchStore = create<RefetchState>()((set, get) => ({
  refetchFunctions: {},

  registerRefetch: (key: string, refetch: () => void) => {
    set((state) => {
      const existing = state.refetchFunctions[key] ?? new Set()
      return {
        refetchFunctions: {
          ...state.refetchFunctions,
          [key]: new Set(existing).add(refetch),
        },
      }
    })
  },

  unregisterRefetch: (key: string, refetch: () => void) => {
    set((state) => {
      const updated = new Set(state.refetchFunctions[key])
      updated.delete(refetch)
      return {
        refetchFunctions: {
          ...state.refetchFunctions,
          [key]: updated,
        },
      }
    })
  },

  triggerRefetch: (key: string) => {
    const {refetchFunctions} = get()
    refetchFunctions[key]?.forEach((refetchFn) => refetchFn())
  },

  triggerAllRefetch: () => {
    const {refetchFunctions} = get()
    Object.values(refetchFunctions).forEach((refetchSet) => {
      refetchSet.forEach((refetchFn) => refetchFn())
    })
  },
}))

// Export hook with same name as before for easier migration
export const useRefetchContext = () => useRefetchStore()
